module.exports = __webpack_public_path__ + "static/droidkaigi2019-89df66476def98c419b6b76e605e9bf7.png";